import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["stroke"];
import { appState } from '@/composable/appState';
import { ACK_ICONS } from '@/helper/const';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CheckCircle',
    setup(__props) {
        const stroke = ref('#475467');
        const setInitialStrokeColor = () => {
            const defaultValue = appState.chatWidgetSettingsData.acknowledgementDetails.icon;
            if (defaultValue === ACK_ICONS.CHECK_CIRCLE) {
                stroke.value = '#155EEF';
            }
            else {
                stroke.value = '#475467';
            }
        };
        watch(() => appState.chatWidgetSettingsData.acknowledgementDetails.icon, newValue => {
            if (newValue === ACK_ICONS.CHECK_CIRCLE) {
                stroke.value = '#155EEF';
            }
            else {
                stroke.value = '#475467';
            }
        });
        setInitialStrokeColor();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                    stroke: stroke.value,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8 /* PROPS */, _hoisted_2)
            ]));
        };
    }
});
